import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const LamnaSynpunkt = lazy(() => import("@/pages/info/LamnaSynpunkt"));

export const Route = createFileRoute("/lamna-synpunkt")({
  head: () => seoHead("/lamna-synpunkt", { description: "Har du förslag på hur vi kan bli bättre, eller vill du berömma något som fungerar bra? Vi läser allt." }),
  component: () => <LamnaSynpunkt />,
});
